export const enum NetcoreEvents {
  dashboard = 'IPS Portal Dashboard Page Load',
  homepage = 'Homepage Load',
  careCenteral = 'Care Cental Page Load',
  patientDirectory = 'Patient Directory Page Load',
  patientPage = 'Patient Page Load',
  currentTreatmentPlanClick = 'Current Treatment Plan Click',
  patientTreatementPlanPage = 'Patient Treatment Plan Page Load',
  dietNutritionButtonClick = 'Diet And Nutrition Button Click',
  dietNutritionPageLoad = 'Diet And Nutrition Page Load',
  dietPlanButtonClick = 'Diet Plan Button Click',
  createNewDietPlanPge = 'Create New Diet Plan Page Load',
  addFoodItemPage = 'Add Food Items Page Load',
  publishButtonClick = 'Publish Button Click',
  mentalHealthPage = 'Mental Health Page Load',
}
export const enum UserType {
  newUser = 1,
  existingUser = 2,
}

export const roleTypes = {
  5: 'Admin',
  6: 'Specialist',
  7: 'Nurse',
  8: 'Doctor',
  9: 'Psychologist',
  10: 'Nutritionist',
  15: 'Others',
};
